import {
    animate,
    AnimationTriggerMetadata,
    style,
    transition,
    trigger,
} from "@angular/animations";

export const tabListAnimations: AnimationTriggerMetadata = trigger(
    "changeList",
    [
        transition("* <=> *", [
            style({
                opacity: 0,
            }),
            animate(
                "0.4s ease",
                style({
                    opacity: 1,
                }),
            ),
        ]),
    ],
);
